<template>
    <div>
        <!-- Optional Banner Section (currently commented out) -->
        <!-- 
      <section class="webSection container-fluid custom-banner-section">
        <div class="custom-section">
          <div class="custom-row-wrap">
          </div>
        </div>
      </section>
      -->

        <div class="limiter" style="display: flex; justify-content: center;">
            <div class="container-login100 shadow" style="margin: 6.25rem;">
                <div class="wrap-login100">
                    <div class="w-100 text-center p-b-32">
                        <img src="../assets/images/logo-light.png" alt="logo" height="80" />
                    </div>

                    <!-- All content inside the form now -->
                    <form @submit.prevent="submitPasswordChange">
                        <!-- Old Password -->
                        <div class="form-group">
                            <label>Old Password <span class="text-danger">*</span></label>
                            <div class="input-group">
                                <input :type="showOldPassword ? 'text' : 'password'" class="form-control"
                                    v-model="oldPassword" required />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" @click.prevent="toggleOldPasswordShow"
                                        type="button">
                                        <i :class="showOldPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- New Password -->
                        <div class="form-group">
                            <label>New Password <span class="text-danger">*</span></label>
                            <div class="input-group">
                                <input :type="showNewPassword ? 'text' : 'password'" class="form-control"
                                    v-model="newPassword" required />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" @click.prevent="toggleNewPasswordShow"
                                        type="button">
                                        <i :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Confirm Password -->
                        <div class="form-group">
                            <label>Confirm Password <span class="text-danger">*</span></label>
                            <div class="input-group">
                                <input :type="showConfirmPassword ? 'text' : 'password'" class="form-control"
                                    v-model="confirmPassword" required />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" @click.prevent="toggleConfirmPasswordShow"
                                        type="button">
                                        <i :class="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Submit Button -->
                        <div class="text-center mt-4">
                            <button class="btn btn-primary" type="submit">
                                Change Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import _ from "underscore";
export default {
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            showOldPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
        };
    },
    methods: {
        toggleOldPasswordShow() {
            this.showOldPassword = !this.showOldPassword;
        },
        toggleNewPasswordShow() {
            this.showNewPassword = !this.showNewPassword;
        },
        toggleConfirmPasswordShow() {
            this.showConfirmPassword = !this.showConfirmPassword;
        },
        async submitPasswordChange() {
            // Basic validation
            if (!this.oldPassword || !this.newPassword || !this.confirmPassword) {
                this.$bvToast.toast("Please fill all the fields", {
                    variant: "danger",
                    solid: true,
                });
                return;
            }

            if (this.newPassword !== this.confirmPassword) {
                this.$bvToast.toast("New password and confirm password do not match", {
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            try {
                let model = {
                    OldPassword: this.oldPassword,
                    NewPassword: this.newPassword,
                    // ConfirmPassword: this.confirmPassword, // Make sure you include this
                };
                axios.post("/api/User/ChangePassword", model)
                    .then((response) => {
                        if (response.data.status === "Success") {
                            this.$bvToast.toast("Password changed successfully!", {
                                variant: "success",
                                solid: true,
                            });
                            // this.$router.push({ name: "SignIn" }); // Redirect to login
                        } else {
                            this.$bvToast.toast(response.data.message || "Something went wrong", {
                                variant: "warning",
                                solid: true,
                            });
                        }
                    })
                    .catch((error) => {
                        this.$bvToast.toast("Error changing password", {
                            variant: "danger",
                            solid: true,
                        });
                        console.error(error);
                    });
            } catch (error) {
                console.error("Unexpected error:", error);
            }

        },
    },
};
</script>

<style scoped>
.container {
    max-width: 500px;
}

.wrap-login100 {
    width: 400px;
    padding: 40px;
    margin: 20px;
}

.content-wrapper {
    display: flex !important;
    justify-content: center !important;
}
</style>